module.exports = __webpack_public_path__ + "img/pic_watch_y908s@2x.c598c8aa.png";